module.exports = __webpack_public_path__ + "static/media/Avenir-Light.a7696fa6.woff";